import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=df5543c2&scoped=true&"
import script from "./OrderCreate.vue?vue&type=script&lang=js&"
export * from "./OrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=df5543c2&lang=scss&scoped=true&"
import style1 from "./OrderCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5543c2",
  null
  
)

export default component.exports